module.exports = __webpack_public_path__ + "statics/img/TargetAudience-4.56eb44b2.png";